"use client";

import { preconnect } from "react-dom";

export function CartoResourceHints() {
  preconnect("https://basemaps.cartocdn.com");
  preconnect("https://tiles.basemaps.cartocdn.com");
  preconnect("https://tiles-a.basemaps.cartocdn.com");
  preconnect("https://tiles-b.basemaps.cartocdn.com");
  preconnect("https://tiles-c.basemaps.cartocdn.com");
  preconnect("https://tiles-d.basemaps.cartocdn.com");
  return null;
}
